<template>
  <BaseModal
    ref="modal"
    modal-classes="max-w-md mx-auto mt-16"
    @modal-after-leave="$emit('closed')"
  >
    <template #header>
      <h3 class="text-2xl text-gray-900">Create Automation</h3>
    </template>

    <template #default="modalProps">
      <AutomationForm
        :automation="{ projectUuid, accountUuid }"
        :submit-action="submitAction"
        @cancel="modalProps.close"
      />
    </template>
  </BaseModal>
</template>

<script>
import { mapActions } from 'vuex';
import AutomationForm from './AutomationForm.vue';

export default {
  components: {
    AutomationForm,
  },

  props: {
    projectUuid: { type: String, required: true },
    accountUuid: { type: String, required: true },
  },

  methods: {
    ...mapActions('ui/projectAutomations', {
      storeAutomation: 'store',
    }),
    submitAction(formData) {
      const { projectUuid } = this;

      return this.storeAutomation({ projectUuid, formData })
        .then((response) => {
          this.$refs.modal.doClose();
          return Promise.resolve(response);
        })
        .catch((error) => Promise.reject(error));
    },
  },
};
</script>
